module.exports = __webpack_public_path__ + "img/filter-search.f0f009c4.svg";